import React from 'react';

import { ExperimentsModeContext } from '@neptune/shared/leaderboard-domain';

export function useExperimentsModeContext() {
  return React.useContext(ExperimentsModeContext);
}
